import React, { useContext } from 'react';
import { useDrag, DragPreviewImage } from 'react-dnd';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import { getInfoToDisplayImageDeviation } from '../DeviationViews/Dumbo/Image/_helpers';
import { DraggableType } from '../types/dnd';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationMediaService from '../utils/DeviationMediaService';
export default function useDeviationDrag(_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _b = useDrag({
        item: { type: DraggableType.DEVIATION, deviation: deviation },
        // !! to prevent any undefineds sneaking through and enabling this by mistake
        canDrag: !!(isLoggedIn && !isMobile),
    }), drag = _b[1], preview = _b[2];
    var type = getDeviationType(deviation);
    var dragPreview = undefined;
    switch (type) {
        case DeviationTypes.IMAGE:
            var info = getInfoToDisplayImageDeviation({
                deviation: deviation,
                width: width,
                height: height,
            });
            if (info) {
                dragPreview = (React.createElement(DragPreviewImage, { connect: preview, src: info.pickedImage.src }));
            }
            break;
        case DeviationTypes.FILM:
            if (width && height) {
                var file = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, width, height);
                if (file) {
                    dragPreview = React.createElement(DragPreviewImage, { connect: preview, src: file.src });
                }
            }
            break;
        default:
    }
    return { dragPreview: dragPreview, drag: drag };
}
//# sourceMappingURL=useDeviationDrag.js.map